import React, { useEffect } from 'react';
import { TreeGraph } from '@antv/g6';
import AIMarks from '../AiMark';
const MindMap = function (props) {
    const { mindMapSummaryListData, courseName, width, height, size = 12, markStyle, disableInteraction = false } = props,
        ref = React.useRef(null);
    let graph = null;

    function modifyData(data) {
        if (Array.isArray(data)) {
            return data.map(modifyData);
        } else if (typeof data === 'object' && data !== null) {
            const { title, children, ...rest } = data;
            let modifiedTitle = title;
            if (title && title.length > 18) {
                for (let i = 18; i < title.length; i += 18) {
                    modifiedTitle = modifiedTitle.slice(0, i) + '\n' + modifiedTitle.slice(i);
                }
            }
            return { ...rest, title: modifiedTitle, children: modifyData(children) };
        }
        return data;
    }

    function modifyDataTitle(title) {
        let titleData = title;
        if (title && title.length > 18) {
            for (let i = 18; i < title.length; i += 18) {
                titleData = titleData.slice(0, i) + '\n' + titleData.slice(i);
            }
        }
        return titleData;
    }

    const mindMap = () => {
        if (mindMapSummaryListData && mindMapSummaryListData?.length > 0) {
            if (!graph) {
                graph = new TreeGraph({
                    container: ref.current,
                    width: width || ref.current?.clientWidth || 450,
                    height: height || 300,
                    pixelRatio: 2,
                    modes: {
                        default: disableInteraction 
                            ? [
                                {
                                    type: 'collapse-expand'
                                }
                            ]
                            : [
                                {
                                    type: 'collapse-expand'
                                },
                                'drag-canvas',
                                'zoom-canvas'
                            ]
                    },
                    defaultEdge: {
                        type: 'cubic-horizontal',
                        style: {
                            stroke: '#A3B1BF',
                            lineWidth: 1
                            // endArrow: true
                        }
                    },
                    defaultNode: {
                        size: 16,
                        anchorPoints: [
                            [0, 0.5],
                            [1, 0.5]
                        ],
                        style: {
                            fill: '#40a9ff',
                            stroke: '#3B70FF'
                        }
                    },
                    layout: {
                        type: 'compactBox',
                        direction: 'LR',
                        getHeight: function getHeight() {
                            return 35;
                        },
                        getWidth: function getWidth() {
                            return 20;
                        },
                        getVGap: function getVGap() {
                            return 20;
                        },
                        getHGap: function getHGap() {
                            return 150;
                        }
                    }
                });
            }
            graph.node(function (node) {
                return {
                    size: 18,
                    style: {
                        fill: node.title && node.children?.length > 0 ? '#3B70FF' : '#fff',
                        stroke: '#3B70FF'
                    },
                    label: node.title,
                    labelCfg: {
                        position: 'top',
                        autoWrap: true, // 开启自动换行
                        ellipsis: true, // 开启文本省略
                        style: {
                            wrapText: true, // 设置 wrap-text 样式
                            textAlign: 'left', // 设置文本对齐方式
                            wordBreak: 'break-all', // 设置单词断行方式
                            fontSize: 16 // 设置字体大小为12
                        }
                    }
                };
            });
            graph.get('canvas').set('localRefresh', false);
            const mindMapData = {
                title: modifyDataTitle(courseName),
                children: modifyData(mindMapSummaryListData)
            };
            graph.data(mindMapData);
            graph.render();
            graph.fitView();
            graph.on('contextmenu', (e) => {
                e.stopPropagation();
                e.preventDefault();
            });
        }
    };

    useEffect(() => {
        mindMap();
    }, [mindMapSummaryListData, courseName]);

    return (
        <div style={{ position: 'relative' }}>
            <div ref={ref}></div>
            <AIMarks index={1} size={size} style={{ color: '#BFBFBF', textAlign: 'right', ...markStyle }} />
        </div>
    );
};
export default MindMap;
